import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import LoginContainer from '../components/Login';
import Spinner from '../components/Spinner';

class Login extends PureComponent {
  render() {
    const { isFetching, logIn, error } = this.props;

    return (
      <div className="flex justify-center align-center h-100">
        <LoginContainer login={logIn} error={error} />
        { isFetching && <Spinner /> }
      </div>
    );
  }
}

export default Login;

Login.propTypes = {
  logIn: PropTypes.func.isRequired,
  error: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/Login.js